
<div class="uploader-status">
    <mat-spinner diameter="40"></mat-spinner>
</div>
